import { createFileRoute } from '@tanstack/react-router';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { employeesService } from '@/features/employees/services/employees.service';
import { ContractSettingsForm } from '@/features/employees/components/ContractSettingsForm';
import { teamsService } from '@/features/teams/services/teams.service';
import { useToast } from '@/hooks/use-toast';

export const Route = createFileRoute('/_authenticated/contracts/settings')({
  component: ContractSettingsPage,
});

function ContractSettingsPage() {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const { data: settings } = useQuery({
    queryKey: ['contract-settings'],
    queryFn: employeesService.getContractSettings,
  });

  const { data: teams = [] } = useQuery({
    queryKey: ['teams'],
    queryFn: () => teamsService.getAll().then((res) => res.data || []),
  });

  const updateSettingsMutation = useMutation({
    mutationFn: employeesService.updateContractSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contract-settings'] });
      toast({ title: 'Configurações atualizadas' });
    },
    onError: () => {
      toast({
        title: 'Erro ao salvar configurações',
        variant: 'destructive',
      });
    },
  });

  if (!settings) {
    return <div className="text-muted-foreground">Carregando configurações...</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Configurações de Contratos</h1>
        <p className="text-muted-foreground">
          Defina prazos e equipe responsável por notificações.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Notificações</CardTitle>
        </CardHeader>
        <CardContent>
          <ContractSettingsForm
            settings={settings}
            teams={teams}
            saving={updateSettingsMutation.isPending}
            onSave={(data) => updateSettingsMutation.mutate(data)}
          />
        </CardContent>
      </Card>
    </div>
  );
}
